import React from "react";
import MembOtpRegChkApi from "Apis/MembOtpRegChkApi";
import { useEffect, useState } from "react";
import { useOutletContext  ,useLocation} from "react-router-dom";
import MbpAthnRsltVrfRqstApi from "Apis/MbpAthnRsltVrfRqstApi";
import MbpAthnUi from "Utils/MbpAthn";
import MembOtpRegApi from "Apis/MembOtpRegApi";
import { Helmet } from "react-helmet-async";
import EtcCtxtApi from "Apis/EtcCtxtApi";
import ApiResultModal from "Components/ApiResultModal";


const MembOtpRegInputUi = () => {
    const location = useLocation();
    const langData:any = useOutletContext();
    const [otpAthnNo,setotpAthnNo] = useState("");
    const [otpAthnNoLbl, setOtpAthnNoLbl] = useState("");
    const [resultModalOpen, setResultModalOpen] = useState(false);
    const [resultModalMessage, setResultModalMessage] = useState("");
    const [modalAction, setModalAction] = useState<(() => void) | null>(null);

    const openResultModal = (message: string, onClose?: () => void) => {
        setResultModalMessage(message);
        setModalAction(() => onClose || null);
        setResultModalOpen(true);
    };

    const closeResultModal = () => {
        setResultModalOpen(false);
        const action = modalAction;
        setModalAction(null);
        if (action) {
            action();
        }
    };

    const OtpRegFunc = () => {
        if (!/^\d{6}$/.test(otpAthnNo)) {
            setOtpAthnNoLbl(
                (langData && langData.MYPAGE_ATHN_NO_INVALID_01) ||
                "인증번호 6자리를 입력해주세요."
            );
            return;
        }

        setOtpAthnNoLbl("");

        MembOtpRegApi(otpAthnNo,location.state?.otpScrt)
        .then(  (resp)=>{
            switch(resp.apiHdr.code) {
                case "MEMB0000":
                    openResultModal(
                        langData&&langData.MYPAGE_OTP_REG_RSLT_LPOP_00,
                        () => { window.location.href="/MyPage"; }
                    );
                break;
                case "ATHN2307":
                    setOtpAthnNoLbl(langData&&langData.MYPAGE_ATHN_NO_INVALID_00);
                break;
                default:
                    openResultModal(resp.apiHdr.msg)
                break;
            }
        })
    }
    const OtpAthnNoHandler = (event:any) => {
        const value = event.currentTarget.value;
        // 숫자만 입력 허용, 최대 6자리
        const numericValue = value.replace(/[^0-9]/g, '').slice(0, 6);
        setotpAthnNo(numericValue);
        setOtpAthnNoLbl("");
    }
        const [otpGUIDECtxtState,setOtpGUIDECtxtState] = useState();
    useEffect(()=>{
        if(!location.state?.qrCdImg) {
            window.location.href="/MyPage";
        }     
        EtcCtxtApi("CTNT_KIND_ETC","OTP_REG_GUIDE","MGP").then((resp)=>{
            setOtpGUIDECtxtState(resp.apiBody.ctxt);
        });
    },[])
    return(
        <>
        <ApiResultModal
            open={resultModalOpen}
            message={resultModalMessage}
            onClose={closeResultModal}
confirmText={langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}
        />
        <Helmet>    
            <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.MYPAGE_MENU_OTP_REG_BTN_00}`}</title>
        </Helmet>
        <div className="container1300 BgW pb200">
            <div className="myPageSubTitlWrap">
                <p className="myPageCtxtTitl">{langData&&langData.MYPAGE_MENU_OTP_REG_BTN_00}</p>
            </div>
            {/* OTP 설정 */}
            <div className="otpRegInputWrap">
                <div className="qrCodeWrap">
                    <div>
                        <img src={location.state?.qrCdImg} alt="" className="qrcdImg"/>
                        <p className="otpScrtKey">{location.state?.otpScrt}</p>
                        <p>{langData&&langData.MYPAGE_OTP_REG_QR_DESC_00}</p>
                    </div>
                    <div className="inputWrap">
                        <input 
                            type="text" 
                            placeholder={`${langData&&langData.MYPAGE_OTP_REG_INPUT_DESC_00}`} 
                            value={otpAthnNo}
                            onChange={OtpAthnNoHandler}
                            maxLength={6}
                        />
                        <button onClick={OtpRegFunc}>
                            <p>{langData&&langData.COMM_MAIN_ATHN_MAIN_BTN_00}</p>
                        </button>
                        <p className="joinInputDesc">{otpAthnNoLbl || '\u00A0'}</p>
                    </div>
                </div>
                <div className="qrCodeDescWrap">
                            { otpGUIDECtxtState != null?
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: otpGUIDECtxtState,
                                    }} className="membLvdCtxtWrap">
                                </div>
                                :
                                <></>

                            }
                </div>
            </div>
        </div>
        </>
    )
}

export default MembOtpRegInputUi;